// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2wSkQ","label":"Radio_label__3rVWp","checkMark":"Radio_checkMark__2KpUq","disabled":"Radio_disabled__1MXl7"};